import { render, staticRenderFns } from "./WorkingHouseBlShppierInfo.vue?vue&type=template&id=352b55fb&scoped=true"
import script from "./WorkingHouseBlShppierInfo.vue?vue&type=script&lang=js"
export * from "./WorkingHouseBlShppierInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkingHouseBlShppierInfo.vue?vue&type=style&index=0&id=352b55fb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b55fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352b55fb')) {
      api.createRecord('352b55fb', component.options)
    } else {
      api.reload('352b55fb', component.options)
    }
    module.hot.accept("./WorkingHouseBlShppierInfo.vue?vue&type=template&id=352b55fb&scoped=true", function () {
      api.rerender('352b55fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingHouseBlShppierInfo.vue"
export default component.exports